module.exports = __webpack_public_path__ + "img/fi-rr-hourglass-end.a4594c33.svg";